'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from 'next/navigation';
import { FILTER_KEY_URL_PARAMS } from '../../Filters.types';
import TimeFilterDropdown from './TimeFilterDropdown';
import TimeFilterSheet from './TimeFilterSheet';

// On desktop, we have a Radio Button for "All times"
export const ALL_TIME_FILTERS_VALUE = 'all';
interface Props {
  handleRouteChange: (newRoute: string) => void;
}
const TimeFilter = t0 => {
  const $ = _c(18);
  const {
    handleRouteChange
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let params;
  let t1;
  if ($[0] !== searchParams) {
    params = new URLSearchParams(searchParams.toString());
    t1 = params.get(FILTER_KEY_URL_PARAMS.START_TIME);
    $[0] = searchParams;
    $[1] = params;
    $[2] = t1;
  } else {
    params = $[1];
    t1 = $[2];
  }
  const selectedTime = t1;
  let resetFilter;
  let updateFilter;
  if ($[3] !== handleRouteChange || $[4] !== params || $[5] !== pathname) {
    updateFilter = filterOption => {
      if (filterOption === ALL_TIME_FILTERS_VALUE) {
        return resetFilter();
      }
      params.set(FILTER_KEY_URL_PARAMS.START_TIME, filterOption);
      handleRouteChange(`${pathname}?${params.toString()}`);
    };
    resetFilter = () => {
      params.delete(FILTER_KEY_URL_PARAMS.START_TIME);
      handleRouteChange(`${pathname}?${params.toString()}`);
    };
    $[3] = handleRouteChange;
    $[4] = params;
    $[5] = pathname;
    $[6] = resetFilter;
    $[7] = updateFilter;
  } else {
    resetFilter = $[6];
    updateFilter = $[7];
  }
  let t2;
  if ($[8] !== resetFilter || $[9] !== selectedTime || $[10] !== updateFilter) {
    t2 = <TimeFilterSheet selectedTime={selectedTime} updateFilter={updateFilter} resetFilter={resetFilter} />;
    $[8] = resetFilter;
    $[9] = selectedTime;
    $[10] = updateFilter;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== selectedTime || $[13] !== updateFilter) {
    t3 = <TimeFilterDropdown selectedTime={selectedTime} updateFilter={updateFilter} />;
    $[12] = selectedTime;
    $[13] = updateFilter;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== t2 || $[16] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
};
export default TimeFilter;